export default {"src":"/_next/static/media/BellIcon-2.b56c33b0.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};